export default __webpack_public_path__ + "static/media/box.6cac2d17.svg";